import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setAddProgress,
        popUpMessageChange, 
        closedCardsGroupsChange,
        editCards, 
        editFeaturesGroup, 
        editFigures } from '../../actions';

import { _ } from '../../functions/translator.js';

import { Button } from '@material-ui/core';

import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';

class AddProgressCard extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            progressValue: 50,
        }
    }

    handleOnClick = async () => {
        const message =  _('Agregando Avance') + '...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            'physical_progress': this.state.progressValue,
            'cards_group_ids': this.props.addProgress.cardsGroupIds,
            'project_id' : window.project_id
        }
        let cardsGroupIds = this.props.addProgress.cardsGroupIds
        this.handleClose()
        let response = await postData('/web-api/add-physical-progress', urlPost)
        this.handleResponse(response, cardsGroupIds)
    }

    handleClose = () => {
        this.props.setAddProgress({})
        this.setState({ progressValue: 50 })
    }

    handleResponse = (response, cardsGroupIds) => {
        const success = response.status === 'success';
        const message = success ? '!' + _('Avance agregado exitosamente') + '!' : _('Ocurrió un error, no se pudo agregar el avance');
        showMessage(this.props, message);
        if (success) {
            reloadCardsGroupsFeatures(this.props, cardsGroupIds);
        }
    }

    handleProgressChange = (event) => {
        this.setState({ progressValue: event.target.value })
    }


    render(){   
        let render = this.props.addProgress.show
        return (
            <div>
                { render ? (
                    <div>
                        <div className='sensitive-background' onClick={this.handleClose}></div>
                        <div className="add-progress-card-layout card-color">
                            <h3 className='text-center'>{_("Ingrese un porcentaje de Avance")}</h3>
                            <h4 className='text-center progress-number'>{ this.state.progressValue + '%'}</h4>
                            <div className='my-4'>
                                <input 
                                type="range" 
                                className="timeslider timeslider-element"
                                min={0}
                                value={this.state.progressValue}
                                max={100}
                                onChange={this.handleProgressChange}/>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <Button variant="contained" onClick={this.handleOnClick} className='success-button'>
                                    <SendIcon/>
                                    <span style={{ paddingLeft: 10 }}>{ _('Agregar Avance')}</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        )
    }
}

function mapStateToProps( state ){
    return {
        addProgress : state.addProgress,
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        setAddProgress : setAddProgress,
        popUpMessageChange : popUpMessageChange,
        closedCardsGroupsChange : closedCardsGroupsChange,
        editFeaturesGroup : editFeaturesGroup,
        editCards : editCards,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AddProgressCard)